import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        main: '#F5F5F5', //#F5F5F5
        cardColour: '#1B2C37',
        primary: '#EF5350',
        secondary: '#E3f6EC',
        accent: '#757575',
        error: '#FF9292',
        info: '#212121',  //#101B24' 
        success: '#4CAF50',
        warning: '#FFC107',
      }
    }
  }
});
